/* Theia — Barra de progreso "Envío gratis" ($43+). Inyecta y mantiene la barra
   en el cart drawer (#CartDrawer-CartItems) y en la página /cart (#main-cart-items .js-contents).
   Umbral en centavos; debe igualar el descuento automático "Envío gratis ($43+)". */
(function () {
  var THRESHOLD = 4300;

  var css =
    '.theia-fsb{padding:1.2rem 1.5rem;border-bottom:.1rem solid rgba(28,28,28,.08);}' +
    '.theia-fsb__text{margin:0 0 .7rem;font-size:1.3rem;line-height:1.3;letter-spacing:.02rem;text-align:center;color:#1C1C1C;}' +
    '.theia-fsb__text strong{font-weight:600;}' +
    '.theia-fsb__track{position:relative;height:.6rem;border-radius:999px;background:rgba(28,28,28,.10);overflow:hidden;}' +
    '.theia-fsb__fill{position:absolute;top:0;left:0;bottom:0;height:100%;border-radius:999px;background:#B89E6F;transition:width .45s cubic-bezier(.22,1,.36,1);}';

  function injectCSS() {
    if (document.getElementById('theia-fsb-css')) return;
    var s = document.createElement('style');
    s.id = 'theia-fsb-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function barHTML(total) {
    var remaining = THRESHOLD - total;
    var pct = total >= THRESHOLD ? 100 : Math.round((total * 100) / THRESHOLD);
    var msg = remaining > 0
      ? 'Te faltan <strong>' + money(remaining) + '</strong> para <strong>envío gratis</strong>'
      : '<strong>¡Felicidades! Tienes envío gratis</strong>';
    return '<div class="theia-fsb" data-theia-fsb>' +
      '<p class="theia-fsb__text">' + msg + '</p>' +
      '<div class="theia-fsb__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
      '<span class="theia-fsb__fill" style="width:' + pct + '%;"></span></div></div>';
  }

  var busy = false;

  function paint(total) {
    var targets = [
      document.getElementById('CartDrawer-CartItems'),
      document.querySelector('#main-cart-items .js-contents')
    ];
    targets.forEach(function (t) {
      if (!t) return;
      var old = t.querySelector('[data-theia-fsb]');
      if (old) old.remove();
      t.insertAdjacentHTML('afterbegin', barHTML(total));
    });
  }

  function refresh() {
    if (busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || c.item_count === 0) {
          document.querySelectorAll('[data-theia-fsb]').forEach(function (e) { e.remove(); });
          return;
        }
        busy = true;
        paint(c.total_price);
        setTimeout(function () { busy = false; }, 60);
      })
      .catch(function () {});
  }

  function watch(sel) {
    var el = document.querySelector(sel);
    if (!el || el.__theiaFsb) return;
    el.__theiaFsb = true;
    new MutationObserver(function () { if (!busy) refresh(); })
      .observe(el, { childList: true, subtree: true });
  }

  function init() {
    injectCSS();
    refresh();
    watch('#CartDrawer');
    watch('#main-cart-items');
    document.addEventListener('cart:refresh', refresh);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
